import { createSlice } from "@reduxjs/toolkit";
import { getRequest, postRequest } from "../../../services/apiCaller/cl_index";
import { endpoints } from "../../../api/ApiEndPoints";

const initialState = {
  staticContent: "",
  linksContent: [], 
};

export const footerSlice = createSlice({
  name: "footer",
  initialState,
  reducers: {
    setStaticContent: (state, action) => {
      state.staticContent = action.payload;
    },
    setLinks: (state, action) => {
      state.linksContent = action.payload;
    },
  },
});

export const { setStaticContent, setLinks } = footerSlice.actions;

export const setFooterContent = (brandid) => (dispatch) => {
  const url = endpoints.footerStaticContent + `/${brandid}`;
  getRequest(url).then((res) => {
    if (res?.status === 200) {
      dispatch(setStaticContent(res?.data));
    } else {
      dispatch(setStaticContent([]));
    }
  });
};

export const setLinksContent = (brandid) => (dispatch) => {
  const url = endpoints.aboutStaticContent + `/${brandid}`;
  postRequest(url).then((res) => {
    if (res?.status === 200) {
      dispatch(setLinks(res?.data));
    } else {
      dispatch(setLinks([]));
    }
  });
};

export default footerSlice.reducer;
